import React from 'react';

const KeyboardIconSvg = ({size = 27, color = 'black'}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 19C3.45 19 2.97933 18.8043 2.588 18.413C2.19667 18.0217 2.00067 17.5507 2 17V7C2 6.45 2.196 5.97933 2.588 5.588C2.98 5.19667 3.45067 5.00067 4 5H20C20.55 5 21.021 5.196 21.413 5.588C21.805 5.98 22.0007 6.45067 22 7V17C22 17.55 21.8043 18.021 21.413 18.413C21.0217 18.805 20.5507 19.0007 20 19H4ZM4 17H20V7H4V17ZM8 16H16V14H8V16ZM5 13H7V11H5V13ZM8 13H10V11H8V13ZM11 13H13V11H11V13ZM14 13H16V11H14V13ZM17 13H19V11H17V13ZM5 10H7V8H5V10ZM8 10H10V8H8V10ZM11 10H13V8H11V10ZM14 10H16V8H14V10ZM17 10H19V8H17V10Z"
            fill={color}/>
    </svg>
);

export default KeyboardIconSvg;